import API from '@/lib/API.js'
import comun from './comun.js'
const Empresas = {
  namespaced: true,
  state: {
    Lista: [],
    Seleccionado: undefined
  },
  mutations: {
    init(state) {
      state = {
        Lista: [],
        Seleccionado: undefined
      };
    },
    set(state, valor) {
      state.Lista = valor;
    },
    select(state, valor) {
      state.Seleccionado = valor;
    },
    setNueva(state) {
      let emp = {
        cod_empre: 0,
        dep: 0,
        denominacion: "",
        domicilio: "",
        codigo_postal: 0,
        telefono: "",
        email: "",
        seccional: 0,
        id_provincia: 0,
        id_localidad: 0,
        cuit: 0,
        id_empresa: 0,
        fecha_alta: "",
        fecha_baja: "",
        observacion: "",
        id_motivo_baja: 0,
      }
      state.Seleccionado = emp
    }
  },
  actions: {
    async FiltrarPorDenominacion({
      commit
    }, valor) {
      commit("comun/cargando")
      let data = []
      data = await API.Empresas.traerPorDenominacion(valor);
      commit("set", data)
      commit("select", undefined)
      commit("comun/fincarga")
    },
    async filtrarPorCuit({
      commit
    }, valor) {
      commit("comun/cargando")
      let data = []
      data = await API.Empresas.traerPorCuit(valor);
      commit("set", data)
      commit("select", undefined)
      commit("comun/fincarga")
    },
    select({
      commit
    }, valor) {
      commit("select", valor)
      commit("set", [])
    },
    async modificarSeleccionada({
      commit,
      state
    }) {
      try {
        let data = []
        let str = ""
        if (state.Seleccionado.id_empresa != 0) {
          data = await API.Empresas.modificar(state.Seleccionado);
          str += "Empresa modificada"
        } else {
          data = await API.Empresas.alta(state.Seleccionado);
          str += `Nueva Empresa de alta '${data.denominacion}'`
        }
        commit("select", data)
        commit("comun/mostrar", str)

      } catch (error) {
        alert(error)
      }
    },
    setNueva({
      commit
    }) {
      commit("setNueva")
    },
  },
  modules: {
    comun,
  }

}
export default Empresas;